import { render, staticRenderFns } from "./PagesOverview.vue?vue&type=template&id=f2212b50&"
import script from "./PagesOverview.vue?vue&type=script&lang=js&"
export * from "./PagesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports